import { useConfig } from '@exam-center/configuration';
import {
  type UserAvatarProps as BaseUserAvatarProps,
  UserAvatar as BaseUserAvatar,
} from '@shared/components';
import { isInternalEmailDomain } from '@shared/utils';

interface UserAvatarProps extends Pick<BaseUserAvatarProps, 'fullName'> {
  email: string;
}

export default function UserAvatar(props: Readonly<UserAvatarProps>) {
  const { fullName, email } = props;

  const configuration = useConfig();

  const internalUserEmailDomains = configuration.userManagement.internalUserEmailDomains;
  const isPrimary = isInternalEmailDomain(email, internalUserEmailDomains);

  return (
    <BaseUserAvatar
      fullName={fullName}
      primary={isPrimary}
      variant='circular'
      sx={{
        width: '44px',
        height: '44px',
      }}
    />
  );
}
